<template>
    <div>               
        <!-- Titulo -->
        <h3 class="mt-1 mb-2 " v-text="titulo"></h3>  
        
        <!-- Tabs -->
        <b-card 
            class="my-3" 
            footer-bg-variant="transparent">             
            <alert
                :variant="alert.variant"                
                dismissible
                :mensagens="alert.mensagens"
                :value="alert.exibir"
                @input="alertDismissed">
            </alert> 
            <form>                    
                <b-row >
                    <b-col class="col-md-6">
                        <b-form-group 
                            label="Categoria" 
                            label-size="sm">                                
                            <b-form-input
                                @keyup.native='alteraDados'  
                                :disabled="acao == 'view'"
                                v-model="categoriaLocal.nome_categoria"
                                aria-describedby="feedback_nome_categoria"
                                :state="$helper.validarEstadoCampo(categoriaLocal.nome_categoria, acao)"
                            >
                            </b-form-input>
                            <b-form-invalid-feedback id="feedback_nome_categoria">Campo Obrigatório.</b-form-invalid-feedback>                                                              
                        </b-form-group>  
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group 
                            label="Situação" 
                            label-size="sm">                                
                            <b-form-radio-group
                                @blur.native='alteraDados'                                                                 
                                id="ind_ativo"    
                                :disabled="acao == 'view'"            
                                :options="ind_ativo.options"                                            
                                v-model="categoriaLocal.ind_ativo"
                                aria-describedby="feedback_ind_ativo"
                                :state="$helper.validarEstadoCampo(categoriaLocal.ind_ativo, acao)"
                            >
                            </b-form-radio-group>
                        </b-form-group> 
                        <b-form-invalid-feedback id="feedback_ind_ativo">Campo Obrigatório.</b-form-invalid-feedback>   
                    </b-col>
                </b-row>                          
            </form>   
            <template v-slot:footer >                                  
                <b-row >  
                    <b-col class="text-left">   
                        <b-button 
                            variant="outline-secondary"                                 
                            @click="voltar"
                        >
                            <i class="fa fa-arrow-left pr-1" ></i>Voltar
                        </b-button>          
                    </b-col>    
                    <b-col class="text-right" >   
                        <b-button 
                            variant="success"   
                            @click="salvar"                            
                        >
                            <i class="fa fa-floppy-o pr-1"></i> Salvar
                        </b-button>          
                    </b-col>                          
                </b-row>
            </template>
       </b-card>
    </div>  
</template>

<script>

import Alert from '../../../models/Alert'
import CategoriaAto from '../../../models/CategoriaAto'

export default {


    data(){
        return { 
            titulo: 'Categoria',
            categoriaLocal: new CategoriaAto(),
            ind_ativo: {
                options:[                        
                    { value: true, text: 'Ativo' },     
                    { value: false, text: 'Inativo' },     
                ],
            },
            alert: new Alert(),
            formAlterado: false, 
            acao: this.$route.path.split('/')[3] === 'visualizar' ? 'view' : 'edit'
        }
    },
    

    methods: {

        alertDismissed(){                    
            this.alert = new Alert();
        }, 

        alteraDados(){
            this.formAlterado = true;
        },

        obter(id){                 
            return this.$api.categoriaAto.obter(id)
                .then(response => {                                            
                    this.categoriaLocal = new CategoriaAto(response.data.data);                                                                                                                                      
                })
                .catch(error => {
                   this.$helper.showAlert(this.alert, 
                                          this.$constantes.alert.variants.DANGER,
                                          error.response.data.errors); 
                });                             
        },

        editarAction(){
            this.$api.categoriaAto.editar(this.categoriaLocal)
                .then(response => {                    
                    if(response.status == 200 || response.status == 201){         
                        this.categoriaLocal = new CategoriaAto(response.data.data);                      
                        this.formAlterado = false;  
                        this.$helper.showAlert(this.alert, 
                                               this.$constantes.alert.variants.SUCCESS,
                                               'Registro atualizado com sucesso!');                             
                    } 
                })
                .catch(error => {                               
                    this.$helper.showAlert(this.alert, 
                                           this.$constantes.alert.variants.DANGER,
                                           error.response.data.errors);
                });  
        },

        
        editar(){
            if( this.categoriaLocal.qtd_atos > 0 ){
                this.$helper.confirmaExclusao(this, 'Esta categoria já está vinculada a um ou mais atos. Sua alteração implicará em todos os atos associados a esta categoria. Deseja continuar?', 'Aviso do sistema', 'warning', 'CONTINUAR')
                    .then(value => {
                        if(value){
                            this.editarAction();  
                        }
                    });
            }else{
                this.editarAction();
            }
        },


        incluir(){          
            this.$api.categoriaAto.incluir(this.categoriaLocal)
                .then(response => {                    
                    if(response.status == 200 || response.status == 201){               
                        this.categoriaLocal = new CategoriaAto(response.data.data);                              
                        this.formAlterado = false;  
                                                
                        this.$router.push({ name: 'categoriaAtoForm', params: { id:this.categoriaLocal.id } })

                        this.$helper.showAlert(this.alert, 
                                               this.$constantes.alert.variants.SUCCESS,
                                               'Registro inserido com sucesso!');                  
                    }
                })
                .catch(error => {  
                    this.$helper.showAlert(this.alert, 
                                           this.$constantes.alert.variants.DANGER,
                                           error.response.data.errors);                                                         
                });  
        },


        mudaPagina(pagina) {
            this.tabela.currentPage = pagina;                    
        },

        salvar(){
            if(this.validaCamposObrigatoriosPreenchidos()){
                if (this.categoriaLocal.id == null){        
                    this.incluir();                                                        
                }else{
                    this.editar();
                }
            }else{
                this.$helper.showAlert(this.alert, 
                                       this.$constantes.alert.variants.DANGER,
                                       'Existe(m) campo(s) obrigatório(s) não preenchido(s).');   
            }                           
        },

        validaCamposObrigatoriosPreenchidos() {
            return (this.categoriaLocal.nome_categoria && 
                    (this.categoriaLocal.ind_ativo == true || this.categoriaLocal.ind_ativo == false) );
        },

        voltar(){
           if(this.formAlterado){
               this.$helper.confirmaVoltar(this, 'Existem alterações que não foram salvas. Deseja mesmo sair ?')
                .then(confirmado => { 
                     if(confirmado){                        
                        this.$router.push({ name: 'categoriasAto'});
                     } 
                });
            } else {
                this.$router.push({ name: 'categoriasAto'}); 
            }           
        },
    },    
   
    mounted(){   
        if(this.$route.params.id === 'new'){
            this.categoriaLocal = new CategoriaAto();
        }else{
            this.obter(this.$route.params.id);
        }
    },

}
</script>


